import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function Flag02StrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M3.25 21.0001V14.0001C3.25 13.5858 3.58579 13.2501 4 13.2501C4.41421 13.2501 4.75 13.5858 4.75 14.0001V21.0001C4.75 21.4143 4.41421 21.7501 4 21.7501C3.58579 21.7501 3.25 21.4143 3.25 21.0001Z"
				fill="currentColor"
			/>
			<path
				d="M3.53516 3.83111C4.99177 2.68227 8.46358 1.29128 12.1025 3.17291C14.5496 4.43808 17.1999 4.4574 19.6895 3.32525C19.9216 3.21969 20.1918 3.23995 20.4062 3.37799C20.6204 3.51601 20.7499 3.75312 20.75 4.00787V14.0235C20.7499 14.2958 20.6022 14.5465 20.3643 14.6788C18.8197 15.5358 15.1656 16.5966 11.4131 14.6563C7.89313 12.8363 5.34863 14.4176 4.56543 15.3174C4.36006 15.5534 4.03028 15.637 3.7373 15.5274C3.44433 15.4178 3.25 15.1381 3.25 14.8253V4.41998C3.2501 4.19048 3.35497 3.97327 3.53516 3.83111ZM11.4131 4.50494C8.66514 3.08411 6.03043 3.95622 4.75 4.80475V13.2657C6.36313 12.3053 8.96949 11.7033 12.1025 13.3233C14.9932 14.8179 17.8225 14.2015 19.25 13.5577V5.10846C16.6638 5.97908 13.9375 5.81026 11.4131 4.50494Z"
				fill="currentColor"
			/>
		</svg>
	);
}

Flag02StrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Flag02StrokeIcon;
